











import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class ExternalLoginBrandButton extends Vue {
  @Prop({ required: true })
  brand: string

  @Emit()
  click(_brand: string) {
    // nothing to do
  }

  get brandLogoImageUrl(): string {
    return `/assets-proxy/images/logo-external-login-${this.brand}.png`
  }
}
